// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-modal:has(.interview-schedule-form) {
  width: min(560px, 92vw);
  max-height: 90vh;
  overflow: auto;
  text-align: left;
}

.confirm-modal:has(.interview-schedule-form) .confirm-icon {
  margin: 0 auto;
}

.confirm-modal:has(.interview-schedule-form) h2,
.confirm-modal:has(.interview-schedule-form) > p {
  text-align: center;
}

.interview-schedule-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: -6px 0 18px;
}

.interview-schedule-form > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.interview-schedule-form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.interview-schedule-form label > span {
  color: #344054;
  font-size: 12px;
  font-weight: 800;
}

.interview-schedule-form input,
.interview-schedule-form textarea {
  width: 100%;
  padding: 10px 11px;
  border: 1px solid #dce2ea;
  border-radius: 9px;
  background: #fff;
  color: #101828;
  outline: 0;
}

.interview-schedule-form input:focus,
.interview-schedule-form textarea:focus {
  border-color: #5b35f5;
  box-shadow: 0 0 0 3px rgba(91, 53, 245, 0.08);
}

.interview-schedule-error {
  margin: -8px 0 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff0f0;
  color: #b42318;
  font-size: 11px;
}

.interview-detail-card {
  border-color: #ddd6fe !important;
  background: linear-gradient(135deg, #fff, #faf9ff);
}

.interview-feedback-item {
  grid-column: span 2;
}

@media (max-width: 600px) {
  .interview-schedule-form > div {
    grid-template-columns: 1fr;
  }

  .interview-feedback-item {
    grid-column: auto;
  }
}

/* Keep scheduling usable inside scrolling application-detail layouts. */
.confirm-overlay {
  position: fixed !important;
  z-index: 2147483000 !important;
  inset: 0 !important;
  display: grid !important;
  place-items: center !important;
  padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left)) !important;
  overflow: auto !important;
  overscroll-behavior: contain;
  background: rgba(15, 23, 42, .68);
  backdrop-filter: blur(5px);
}

.confirm-modal:has(.interview-schedule-form) {
  width: min(560px, 100%) !important;
  max-width: calc(100vw - 32px) !important;
  max-height: calc(100dvh - 32px) !important;
  margin: auto;
  padding: 26px 28px 22px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.confirm-modal:has(.interview-schedule-form) .confirm-icon {
  width: 52px;
  height: 52px;
  font-size: 24px;
}

.confirm-modal:has(.interview-schedule-form) h2 {
  margin: 13px 0 7px;
  font-size: 21px;
}

.confirm-modal:has(.interview-schedule-form) > p {
  margin: 0 auto 18px;
  max-width: 470px;
  line-height: 1.5;
}

.confirm-modal:has(.interview-schedule-form) .confirm-buttons {
  position: sticky;
  z-index: 2;
  bottom: -22px;
  margin: 0 -28px -22px;
  padding: 14px 28px 22px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

@media (max-height: 680px) {
  .confirm-modal:has(.interview-schedule-form) {
    padding-top: 18px;
  }
  .confirm-modal:has(.interview-schedule-form) .confirm-icon {
    width: 42px;
    height: 42px;
    font-size: 20px;
  }
  .confirm-modal:has(.interview-schedule-form) h2 {
    margin-top: 8px;
  }
}

@media (max-width: 600px) {
  .confirm-overlay {
    padding: 10px !important;
  }
  .confirm-modal:has(.interview-schedule-form) {
    max-width: calc(100vw - 20px) !important;
    max-height: calc(100dvh - 20px) !important;
    padding: 20px 16px 16px !important;
    border-radius: 16px;
  }
  .confirm-modal:has(.interview-schedule-form) .confirm-buttons {
    bottom: -16px;
    margin: 0 -16px -16px;
    padding: 12px 16px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/InterviewSchedule.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wEAAwE;AACxE;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,yKAAyK;EACzK,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0CAA0C;EAC1C,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wCAAwC;IACxC,0CAA0C;IAC1C,kCAAkC;IAClC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,uBAAuB;EACzB;AACF","sourcesContent":[".confirm-modal:has(.interview-schedule-form) {\n  width: min(560px, 92vw);\n  max-height: 90vh;\n  overflow: auto;\n  text-align: left;\n}\n\n.confirm-modal:has(.interview-schedule-form) .confirm-icon {\n  margin: 0 auto;\n}\n\n.confirm-modal:has(.interview-schedule-form) h2,\n.confirm-modal:has(.interview-schedule-form) > p {\n  text-align: center;\n}\n\n.interview-schedule-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: -6px 0 18px;\n}\n\n.interview-schedule-form > div {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.interview-schedule-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.interview-schedule-form label > span {\n  color: #344054;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.interview-schedule-form input,\n.interview-schedule-form textarea {\n  width: 100%;\n  padding: 10px 11px;\n  border: 1px solid #dce2ea;\n  border-radius: 9px;\n  background: #fff;\n  color: #101828;\n  outline: 0;\n}\n\n.interview-schedule-form input:focus,\n.interview-schedule-form textarea:focus {\n  border-color: #5b35f5;\n  box-shadow: 0 0 0 3px rgba(91, 53, 245, 0.08);\n}\n\n.interview-schedule-error {\n  margin: -8px 0 12px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #fff0f0;\n  color: #b42318;\n  font-size: 11px;\n}\n\n.interview-detail-card {\n  border-color: #ddd6fe !important;\n  background: linear-gradient(135deg, #fff, #faf9ff);\n}\n\n.interview-feedback-item {\n  grid-column: span 2;\n}\n\n@media (max-width: 600px) {\n  .interview-schedule-form > div {\n    grid-template-columns: 1fr;\n  }\n\n  .interview-feedback-item {\n    grid-column: auto;\n  }\n}\n\n/* Keep scheduling usable inside scrolling application-detail layouts. */\n.confirm-overlay {\n  position: fixed !important;\n  z-index: 2147483000 !important;\n  inset: 0 !important;\n  display: grid !important;\n  place-items: center !important;\n  padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left)) !important;\n  overflow: auto !important;\n  overscroll-behavior: contain;\n  background: rgba(15, 23, 42, .68);\n  backdrop-filter: blur(5px);\n}\n\n.confirm-modal:has(.interview-schedule-form) {\n  width: min(560px, 100%) !important;\n  max-width: calc(100vw - 32px) !important;\n  max-height: calc(100dvh - 32px) !important;\n  margin: auto;\n  padding: 26px 28px 22px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n}\n\n.confirm-modal:has(.interview-schedule-form) .confirm-icon {\n  width: 52px;\n  height: 52px;\n  font-size: 24px;\n}\n\n.confirm-modal:has(.interview-schedule-form) h2 {\n  margin: 13px 0 7px;\n  font-size: 21px;\n}\n\n.confirm-modal:has(.interview-schedule-form) > p {\n  margin: 0 auto 18px;\n  max-width: 470px;\n  line-height: 1.5;\n}\n\n.confirm-modal:has(.interview-schedule-form) .confirm-buttons {\n  position: sticky;\n  z-index: 2;\n  bottom: -22px;\n  margin: 0 -28px -22px;\n  padding: 14px 28px 22px;\n  border-top: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n@media (max-height: 680px) {\n  .confirm-modal:has(.interview-schedule-form) {\n    padding-top: 18px;\n  }\n  .confirm-modal:has(.interview-schedule-form) .confirm-icon {\n    width: 42px;\n    height: 42px;\n    font-size: 20px;\n  }\n  .confirm-modal:has(.interview-schedule-form) h2 {\n    margin-top: 8px;\n  }\n}\n\n@media (max-width: 600px) {\n  .confirm-overlay {\n    padding: 10px !important;\n  }\n  .confirm-modal:has(.interview-schedule-form) {\n    max-width: calc(100vw - 20px) !important;\n    max-height: calc(100dvh - 20px) !important;\n    padding: 20px 16px 16px !important;\n    border-radius: 16px;\n  }\n  .confirm-modal:has(.interview-schedule-form) .confirm-buttons {\n    bottom: -16px;\n    margin: 0 -16px -16px;\n    padding: 12px 16px 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
